module.exports = __webpack_public_path__ + "img/capeMay.11ca3fd4.jpg";